import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderDefaultFieldRenderer } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-default-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderDefaultField(
  field: SchemaField,
  indent: string,
  label: string,
  fieldType: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const fieldProps = defaultValueFromHandler
    ? renderDefaultFieldRenderer({
        kind: 'renderDefaultFieldChangeHandlerTemplate',
        props: {
          indent: indent,
          defaultValueFromHandler: defaultValueFromHandler
        }
      })
    : '{...formField}'
  return renderDefaultFieldRenderer({
    kind: 'renderDefaultFieldFormFieldTemplate',
    props: {
      indent: indent,
      fieldName: field.name,
      formItemProps: formItemProps(field),
      labelWithDescription: labelWithDescription(
        formLabel(field, label),
        hintJSX,
        `${indent}      `
      ),
      fieldType: fieldType,
      toLowerCase: label.toLowerCase(),
      fieldProps: fieldProps
    }
  })
}
